import { createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit"
import { selectorOf } from "../../../common/utils/redux-helpers"
import { ReqStatus } from "../../../common/utils/utils"
import { fetchChromaticUrl } from "./test-hub-api"
import { DecryptionState, EncryptionState, InfoConversionStatus, SensitiveData } from "./test-hub-model"

export const initialDecryptionState: DecryptionState = {
    data: null,
    status: InfoConversionStatus.READY,
}

export const initialEncryptionState: EncryptionState = {
    data: "",
    status: InfoConversionStatus.READY,
}

export const infoDecryptionSlice = createSlice({
    initialState: initialDecryptionState,
    name: "infoDecryption",
    reducers: {
        getDecryptedInfoFailure(state, { payload: { error } }: PayloadAction<{ error: string }>) {
            state.error = error
            state.status = InfoConversionStatus.ERROR
        },
        getDecryptedInfoStart(state) {
            state.data = null
            state.error = undefined
            state.status = InfoConversionStatus.LOADING
        },
        getDecryptedInfoSuccess(state, { payload: { data } }: PayloadAction<{ data: SensitiveData }>) {
            state.data = data
            state.status = InfoConversionStatus.SUCCESS
        },
    },
})

export const infoEncryptionSlice = createSlice({
    initialState: initialEncryptionState,
    name: "infoEncryption",
    reducers: {
        getEncryptedInfoFailure(state, { payload: { error } }: PayloadAction<{ error: string }>) {
            state.error = error
            state.status = InfoConversionStatus.ERROR
        },
        getEncryptedInfoStart(state) {
            state.data = null
            state.error = undefined
            state.status = InfoConversionStatus.LOADING
        },
        getEncryptedInfoSuccess(state, { payload: { data } }: PayloadAction<{ data: string }>) {
            state.data = data
            state.status = InfoConversionStatus.SUCCESS
        },
    },
})

export const { getDecryptedInfoFailure, getDecryptedInfoStart, getDecryptedInfoSuccess } = infoDecryptionSlice.actions
export const { getEncryptedInfoFailure, getEncryptedInfoStart, getEncryptedInfoSuccess } = infoEncryptionSlice.actions

export const decryptedInfoSelector = selectorOf((s) => s.debugDecryption)
export const encryptedInfoSelector = selectorOf((s) => s.debugEncryption)

export interface ChromaticUrlState {
    data?: string
    error?: SerializedError
    status: ReqStatus
}

export const chromaticUrlSlice = createSlice({
    initialState: {
        data: undefined,
        error: undefined,
        status: ReqStatus.READY,
    } as ChromaticUrlState,
    name: "chromaticUrl",
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchChromaticUrl.pending, (state) => {
                if (state.status === ReqStatus.READY) {
                    state.status = ReqStatus.WAITING
                }
            })
            .addCase(fetchChromaticUrl.fulfilled, (state, action) => {
                if (state.status === ReqStatus.WAITING) {
                    state.status = ReqStatus.SUCCESS
                    state.data = action.payload
                }
            })
            .addCase(fetchChromaticUrl.rejected, (state, action) => {
                if (state.status === ReqStatus.WAITING) {
                    state.status = ReqStatus.FAILED
                    state.error = action.error
                }
            })
    },
})

export const chromaticSelector = selectorOf((s) => s.chromaticUrl)
